import { Controller } from "@hotwired/stimulus";
import map from "lodash/map";
import { v4 as uuid } from "uuid";

export default class extends Controller<HTMLElement> {
  static targets = ["target", "template"];
  declare templateTarget: HTMLElement;
  declare targetTarget: HTMLElement;

  add(evt: Event): void {
    evt.preventDefault();

    const wrappers: NodeListOf<HTMLElement> = document.querySelectorAll("[data-wrapper]");
    let maxIndex: number;
    if (wrappers.length === 0) {
      maxIndex = 0;
    } else {
      const maxFound = Math.max(
        ...map(wrappers, (wrapper) => parseInt(wrapper.dataset.index || "0", 10)),
      );
      maxIndex = maxFound + 1;
    }

    const content: string = this.templateTarget.innerHTML.replace(/RECORD_REF/g, uuid());

    this.targetTarget.insertAdjacentHTML("beforebegin", content);
  }

  remove(evt: Event): void {
    evt.preventDefault();

    if (!(evt.target instanceof HTMLElement)) {
      return;
    }

    const wrapper: HTMLElement | null = evt.target.closest("[data-wrapper]");
    if (!wrapper) {
      return;
    }

    const inputs: NodeListOf<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> =
      wrapper.querySelectorAll('input:not([type="hidden"]), textarea, select');
    inputs.forEach((input) => {
      input.disabled = true;
    });

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove();
    } else {
      wrapper.style.display = "none";

      const input: HTMLInputElement | null = wrapper?.querySelector("input[name*='_destroy']");
      if (input) {
        input.value = "1";
      }
    }
  }
}
